import types from 'actions/types'
import {combineReducers} from "redux"

export const loading = (state = false, action) => {
  switch (action.type) {
    case types.PRICING_CALCULATORS_LOAD_ATTEMPT:
      return true

    case types.PRICING_CALCULATORS_LOAD_FAILURE:
      return false

    case types.PRICING_CALCULATORS_LOAD_SUCCESS:
      return false

    default: return state
  }
}

export const data = (state = [], action) => {
  switch (action.type) {
    case types.PRICING_CALCULATORS_LOAD_SUCCESS:
      return action.data

    default: return state
  }
}

export const loadingForm = (state = false, action) => {
  switch (action.type) {
    case types.PRICING_CALCULATOR_FORM_LOAD_ATTEMPT:
      return true

    case types.PRICING_CALCULATOR_FORM_LOAD_FAILURE:
      return false

    case types.PRICING_CALCULATOR_FORM_LOAD_SUCCESS:
      return false

    default: return state
  }
}

export const form = (state = [], action) => {
  switch (action.type) {
    case types.PRICING_CALCULATOR_FORM_LOAD_SUCCESS:
      return action.data

    default: return state
  }
}

export const loadingMaster = (state = false, action) => {
  switch (action.type) {
    case types.PRICING_CALCULATOR_MASTER_LOAD_ATTEMPT:
      return true

    case types.PRICING_CALCULATOR_MASTER_LOAD_FAILURE:
      return false

    case types.PRICING_CALCULATOR_MASTER_LOAD_SUCCESS:
      return false

    default: return state
  }
}

export const master = (state = null, action) => {
  switch (action.type) {
    case types.PRICING_CALCULATOR_MASTER_LOAD_ATTEMPT:
      return null

    case types.PRICING_CALCULATOR_MASTER_LOAD_SUCCESS:
      return action.data

    // Optimistic update
    case types.PRICING_CALCULATOR_MASTER_UPDATE_ATTEMPT:
      return action.data

    case types.PRICING_CALCULATOR_MASTER_UPDATE_SUCCESS:
      return {
        ...state,
        ...action.data,
      }

    default: return state
  }
}

export default combineReducers({
  loading,
  data,
  loadingForm,
  form,
  loadingMaster,
  master,
})
